import React from 'react';
import ReactDOM from 'react-dom/client';
import { hydrate, render } from "react-dom";
import './styles/index.css';
import './styles/fonts.css'
import { GlobalStyles } from 'twin.macro'
import App from './App';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Locale from "./data/locale.json";




const Index = () => <React.StrictMode>
  <GlobalStyles />
  <BrowserRouter basename='/island-craft-calculator/'>
    <Routes>
      <Route exact path="/" element={<App lang={""}/>} />
      {Object.keys(Locale).map((lang,index) =>
        <Route path={`/${Locale[lang].code}`} key={`route_${lang}`} element={<App lang={lang}/>} />
      )}
      <Route path="*" element={<App lang={""}/>} />
    </Routes>
  </BrowserRouter>
</React.StrictMode>

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(Index);
const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(<Index />, rootElement);
} else {
  render(<Index />, rootElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
